import React from "react";
import { Box, Typography } from "@mui/material";
import QuoteDeliveryFee from "./QuoteDeliveryFee";
import moment from "moment";

export default function QuoteFooterInfo(props) {
  let { status, expiration } = props;

  const hoursToExpiration = moment(expiration).diff(moment(), "hours");

  if (status === "expired") {
    return (
      <Box>
        <Box style={{ textDecoration: "line-through" }}>
          <Typography variant="h4" color="textSecondary">
            ${Math.round(+props.quote.quote)}
          </Typography>
          <QuoteDeliveryFee option={props.quote.option} fee={props.quote.delivery} />
        </Box>
        <Typography variant="caption" color="error">
          Quote expired
        </Typography>
      </Box>
    );
  } else if (props.quote.quote) {
    return (
      <Box>
        <Typography variant="h4">${Math.round(+props.quote.quote)}</Typography>
        <QuoteDeliveryFee option={props.quote.option} fee={props.quote.delivery} />
        <Box>
          <Typography variant="caption" color={hoursToExpiration > 6 ? "textSecondary" : "error"}>
            quote expires {moment(expiration).fromNow()}
          </Typography>
        </Box>
      </Box>
    );
  } else {
    return <Box />;
  }
}
